































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import QuicksightDashboard from '@/components/QuicksightDashboard.vue';
import {Application} from '@/types';
import {Getter} from 'vuex-class';
import ApplicationService from '@/services/application.service';
import {Route} from 'vue-router';

@Component({
  components: {QuicksightDashboard},
})
export default class ApplicationContainer extends Vue {

  private get getNRUrl() {
    let url = '';
    if (this.currentApplication!.type === 'nodered') {
      url = this.currentApplication!.reference;
    }
    return url;
  }
  @Getter private hasPermission: any;
  @Getter private applications!: any;
  @Getter private activeOrganisationId!: any;
  @Getter private login!: any;
  @Getter private activeOrganisation: any;
  private applicationSelected: boolean = false;
  private currentApplication: Application | null = null;
  private selectedAppUrl: string | null = null;
  private key = 0;

  public async resetCurrentApplication() {
    this.$router.push({name: 'consume-home', params: { organisationId: this.activeOrganisationId }});
    this.currentApplication = null;
    this.applicationSelected = false;
  }

  @Watch('activeOrganisationId')
  private onOrgSwitch() {
    this.resetCurrentApplication();
  }

  private async mounted() {
    this.currentApplication = null;
    this.applicationSelected = false;
    const appStringId = this.$route.params.id;
    if (appStringId && Number(appStringId) > 0) {
      const appId = Number(appStringId);
      const applications = this.applications.applications;
      for (const application of applications) {
        if (application.id === appId) {
          this.currentApplication = application;
          this.applicationSelected = true;
          this.setSelectedAppUrl();
          break;
        }
      }
      if (!this.applicationSelected) {
        this.$router.push({name: 'consume-home', params: { organisationId: this.activeOrganisationId }});
      }
    }
  }

  private async setSelectedAppUrl() {
    if (this.currentApplication) {
      if (this.currentApplication.type === 'daizy') {
        const { sessionId } = await ApplicationService.getApplicationSessionId(this.currentApplication.id);
        this.selectedAppUrl = this.currentApplication.src + '?token=' + sessionId;
      } else if (this.currentApplication.type === 'external') {
        if (process.env.NODE_ENV === 'production' && this.activeOrganisationId === 15) {
          const deviceLabToken = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjIzOCwidXNlckVtYWlsIjoiYXBpLXVzZXItMTY0NDg2MzkxMzk0NCIsImlhdCI6MTY0NDg2MzkxNH0.UcIZ1LaZUzEOVHExrPLXy1M_tpr2xA40Sgo7yPOUFrE`;
          this.selectedAppUrl = `${this.currentApplication.src}?token=${deviceLabToken}`;
          return;
        }
        this.selectedAppUrl = this.currentApplication.src.includes('?token') ? this.currentApplication.src : `${this.currentApplication.src}?token=${this.login.token}&orgId=${this.activeOrganisationId}&orgSlug=${this.activeOrganisation[0].slug}`;
      } else {
        this.selectedAppUrl = this.currentApplication.src;
      }
    }
  }



}
